import AddIcon from '@mui/icons-material/Add'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { useState } from 'react'
import { Link } from 'react-router'
import { useRoutes } from '../../../store'
import { useSettingsSelector, useUser } from '../../../utils'
import Divider from '@mui/material/Divider'
import ListSubheader from '@mui/material/ListSubheader'
import { Role } from 'common/api/v1/types'
import { AddEdgeConnectDialog } from '../../appliances/AddEdgeConnectDialog'
import ListItemIcon from '@mui/material/ListItemIcon'
import { Theme } from '@mui/material/styles'
import ListItemButton from '@mui/material/ListItemButton'

export const GlobalCreate = ({ devMode }: { devMode?: boolean }) => {
  const { settings } = useSettingsSelector()
  const expFeatures = settings?.expFeatures
  const routes = useRoutes()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)
  const user = useUser()
  const [showAddEdgeConnectDialog, setShowAddEdgeConnectDialog] = useState(false)

  if (![Role.super, Role.admin].includes(user.role)) return null

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  return (
    <>
      <ListItemButton
        dense
        onClick={handleClick}
        sx={{
          padding: (theme: Theme) => theme.spacing(1.2, 2) + ' !important', // FIXME: Remove important
          flexGrow: 0,
          cursor: 'pointer',
        }}
      >
        <ListItemIcon sx={{ minWidth: '34px', color: 'inherit' }}>{<AddIcon />}</ListItemIcon>
        <ListItemText sx={{ paddingLeft: 0 }} primary="Create new..." />
      </ListItemButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <ListSubheader>Streaming</ListSubheader>
        <MenuItem component={Link} to={routes.inputsNew()} onClick={handleClose}>
          <ListItemText primary="Input" />
        </MenuItem>
        <MenuItem component={Link} to={routes.outputsNew()} onClick={handleClose}>
          <ListItemText primary="Output" />
        </MenuItem>
        <MenuItem component={Link} to={routes.outputListsNew()} onClick={handleClose}>
          <ListItemText primary="Output List" />
        </MenuItem>
        <Divider />

        <ListSubheader>Administration</ListSubheader>
        {user.role === Role.super && (
          <MenuItem component={Link} to={routes.usersNew()} onClick={handleClose}>
            <ListItemText primary="User" />
          </MenuItem>
        )}
        {user.role === Role.super && (
          <MenuItem component={Link} to={routes.groupsNew()} onClick={handleClose}>
            <ListItemText primary="Group" />
          </MenuItem>
        )}
        <MenuItem component={Link} to={routes.groupListsNew()} onClick={handleClose}>
          <ListItemText primary="Group List" />
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            handleClose(e)
            setShowAddEdgeConnectDialog(true)
          }}
        >
          <ListItemText primary="Edge Connect" />
        </MenuItem>
        <Divider />

        <ListSubheader>Networking</ListSubheader>
        <MenuItem component={Link} to={routes.addressMappingsNew()} onClick={handleClose}>
          <ListItemText primary="Address Mapping" />
        </MenuItem>
        {user.role === Role.super && (
          <MenuItem component={Link} to={routes.networkNew()} onClick={handleClose}>
            <ListItemText primary="Network" />
          </MenuItem>
        )}

        {devMode && expFeatures?.ExtDerivedInput && (
          <>
            <Divider />
            <ListSubheader>Transcoding</ListSubheader>
            <MenuItem component={Link} to={routes.overlaysNew()} onClick={handleClose}>
              <ListItemText primary="Overlay" />
            </MenuItem>
          </>
        )}

        {expFeatures?.AdInsertion && (
          <>
            <Divider />
            <ListSubheader>Ad insertion</ListSubheader>
            <MenuItem component={Link} to={routes.adCreativesNew()} onClick={handleClose}>
              <ListItemText primary="Creative" />
            </MenuItem>
            <MenuItem component={Link} to={routes.adPodsNew()} onClick={handleClose}>
              <ListItemText primary="Pod" />
            </MenuItem>
            <MenuItem component={Link} to={routes.adServersNew()} onClick={handleClose}>
              <ListItemText primary="External Ad Server" />
            </MenuItem>
          </>
        )}
      </Menu>
      {showAddEdgeConnectDialog && (
        <AddEdgeConnectDialog
          user={user}
          open={showAddEdgeConnectDialog}
          onClose={() => setShowAddEdgeConnectDialog(false)}
        />
      )}
    </>
  )
}
